// @ utilities
const { APIGet } = require('utilities/APIRequestHelper');
// @ constants
const actionTypes = require('constants/actionTypes');

const requestCardRewards = () => ({
    type: actionTypes.FETCH_CARD_REWARDS_REQUEST,
});

const resetCardRewards = () => ({
    type: actionTypes.FETCH_CARD_REWARDS_RESET,
});

const requestCardRewardsSuccess = (data, immCard) => ({
    type: actionTypes.FETCH_CARD_REWARDS_SUCCESS,
    payload: {
        data: data,
        immCard,
    }
});

const requestCardRewardsFailure = error => ({
    type: actionTypes.FETCH_CARD_REWARDS_FAILURE,
    payload: {
        error,
    }
});

const requestRewards = cardId => (dispatch, getState) => {
    const immCard = getState().cards.getIn(['byId', cardId]);
    const immCardContract = immCard.get('contract');
    const params = {
        header: { version: 3 },
        query: {
            contractNumber: `${immCardContract.get('product')}${immCardContract.get('number')}`,
        }
    };

    dispatch(requestCardRewards());

    return APIGet({dispatch, endpoint:'cardRewards', params })
        .then(response => dispatch(requestCardRewardsSuccess(response, immCard)))
        .catch(response => {
            if (!!response.error) {
                dispatch(requestCardRewardsFailure(response.error));
            } else {
                 throw response;
            }
        })
};

module.exports = {
    requestRewards,
    resetCardRewards,
};
